
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useCustomSearchSetter from "customHooks/useCustomSearchSetter";
import useMobile from "customHooks/useMobile";
import useRTL from "customHooks/useRTL";
import useUtilities from "customHooks/useUtilities";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import DonateCard from "../../components/Donate/DonateCard";
import SEO from "../../components/Seo";
import GeneralDonateLayout from "../../layout/GeneralDonateLayout";
import { donationCardsRoutes } from "../../public/static-data/routesArray";
const Donate = () => {
    const isMobile = useMobile("lg");
    const { locale, replace, pathname } = useRouter();
    const { t } = useTranslation("common");
    const showQuick = () => {
        replace(pathname + "#quick_donate");
    };
    const { data: utilities } = useUtilities();
    const targetTypes = utilities?.target_types;
    const donationCards = utilities?.donation_sections;
    const data = donationCards?.map((item) => {
        const route = item.target_types
            ? targetTypes?.[item.target_types[0]].page_path
            : donationCardsRoutes?.[item.key]?.path;
        return {
            constant: item?.name[locale],
            desc: item?.description[locale],
            route,
            icon: item.icon,
            key: item.key
        };
    });
    const isRTL = useRTL();
    useCustomSearchSetter({
        customSearch: {
            icon: "fe-zap fs-xxl ",
            onClick: showQuick
        }
    });
    return (<>
      <SEO title={t("donate")} description={t(`sections_donate_jumbtron_desc`)}/>
      <div>
        <ul className={`${!isMobile
            ? "nav nav-tabs mb-0 media-tabs row pt-4 pb-5"
            : "donate-grid px-0"}`} role="tablist">
          {data?.map((item, idx) => {
            const isLast = isEven(data?.length)
                ? idx === data?.length - 1 || idx === data?.length - 2
                : idx === data?.length - 1;
            const isEvenIndex = isEven(idx);
            // const Icon = donationCardsRoutes?.[item.key]?.icon || null;
            return (<DonateCard key={item.constant} data={item} isLast={isLast} bLeft={isRTL ? isEvenIndex : null} bRight={isRTL ? null : isEvenIndex}/>);
        })}
        </ul>
      </div>
    </>);
};
export default Donate;
Donate.Layout = GeneralDonateLayout;
function isEven(num) {
    return num % 2 === 0 ? true : false;
}

    async function __Next_Translate__getStaticProps__1a13f66be1c__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/donate/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66be1c__ as getStaticProps }
  